import { ImpactCo2Answer } from '@/domain/impact-co2/entities/question.entity';

import { HttpService } from '../../http-service';
import { ImportImpactAnswersCo2Mapper } from './import-responses-co2.mapper';

const http = new HttpService({ baseURL: import.meta.env.VITE_API_IMPACT });

export async function importImpactAnswers(
  projectId: number,
  answers: ImpactCo2Answer[],
  deleteExistingImportedResponses: boolean,
) {
  const url = `/import-responses-co2`;
  const responses = ImportImpactAnswersCo2Mapper.prepareResponses(
    answers,
    projectId,
  );
  const data = {
    projectId,
    responses,
    deleteExistingImportedResponses,
  };
  await http.post(url, data);
}
